import { initializeApp } from "firebase/app";
import { 
  getMessaging, 
  getToken, 
  isSupported as FirebaseIsSupported,
  onMessage
} from "firebase/messaging";

export const firebaseConfig = {
  apiKey: "AIzaSyCP_YhicMNytQ78iMpeIAE3FEqUxwW9FsU",
  authDomain: "lucksy-51b87.firebaseapp.com",
  projectId: "lucksy-51b87",
  storageBucket: "lucksy-51b87.firebasestorage.app",
  messagingSenderId: "255777423533",
  appId: "1:255777423533:web:80f79a875cb7435e1b8624",
  measurementId: "G-4Q729Q1XSQ"
};

export const FIREBASE_VAPID_KEY =
  "BJXwVhHkfql9cAjTH5M5UbMoBWsAHwF7DtwOiA5_udZKi8bnA0C5D4J8lRxhKOJorPAv1g_EkA7Q7wXkkxk3l48";

const app = initializeApp(firebaseConfig);

let messaging = null;

if ("Notification" in window) {
  messaging = getMessaging(app);
}

/* -------------------------------------------------
   CHECK SUPPORT
---------------------------------------------------*/
export const isSupported = () => {
  return (
    "Notification" in window &&
    "serviceWorker" in navigator &&
    "PushManager" in window
  );
};

export const isAppStandalone = () => {
  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  if (window.navigator.standalone === true) return true;
  return false;
};

/* -------------------------------------------------
   REQUEST TOKEN
---------------------------------------------------*/
export const requestForToken = async () => {
  try {
    return getToken(messaging, { vapidKey: FIREBASE_VAPID_KEY })
      .then(async currentToken => {
        if (currentToken) return currentToken;
        return null;
      })
      .catch(() => null);
  } catch (e) {
    return null;
  }
};

/* -------------------------------------------------
   CLICK HANDLER FOR FOREGROUND NOTIFICATIONS
---------------------------------------------------*/
function handleForegroundNotificationClick(data) {
  const origin = window.location.origin;

  // 1. Log click
  fetch(`${origin}/notifications/click`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      message_id: data.message_id || null,
      click_action: data.click_action || null,
      timestamp: Date.now()
    })
  }).catch(() => {});

  // 2. Redirect
  let url = data.click_action || origin;

  const urlObj = new URL(url, origin);

  if (data.message_id) {
    urlObj.searchParams.append("message_id", data.message_id);
  }

  window.location.href = urlObj.toString();
}

/* -------------------------------------------------
   FOREGROUND MESSAGE HANDLER
---------------------------------------------------*/
export const initForegroundMessaging = () => {
  if (!messaging) return;

  onMessage(messaging, payload => {
    window.alert(JSON.stringify(payload));

    const data = JSON.parse(payload?.data?.data || "{}");

    // Show the notification manually in foreground
    const notification = new Notification(payload.data.title, {
      body: payload.data.body,
      icon: payload.data.icon,
      image: payload.data.image,
      data
    });

    notification.onclick = () => {
      handleForegroundNotificationClick(data);
    };
  });
};
